export const zhCNStr = 'zh-CN';
export const enUSStr = 'en-US';

export const userServicesAgreementStr = 'https://www.fuxinsoft.cn/trust/eula';

export const privacyPolicyStr = 'https://www.fuxinsoft.cn/trust/privacy';

export const callQQStr =
    'tencent://Message/?Uin=2881472761&amp;site=qq&amp;menu=yes';

export const helpCenterStr = 'https://docs.foxithd.com/';

export const yuqueDocsUrl = 'https://www.yuque.com/xiaoj-desvs/wux3o9';

export const operationManual =
    'https://www.yuque.com/xiaoj-desvs/wux3o9/tlq1ek';

export const collaborationClientType = 1; //pdf 协同编辑时 客户端标识  1 pc 2 微信公众号 3 app 端
export const redirectList = ['/home/ai', '/collection-share', '/invite'];
